<script setup lang="ts">
import { Button } from "@/components/ui/button"
import { Icon } from "@iconify/vue"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Sheet, SheetTitle, SheetDescription, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import Separator from "@/components/ui/separator/Separator.vue"
import { Search } from "lucide-vue-next"

const props = defineProps<{
  imageSrc: string
  items: any[]
}>()

const isActive = (item: any): boolean => {
  return item.path === window.location.pathname
}
</script>

<template>
  <Sheet>
    <SheetTrigger as-child>
      <Button variant="outline" size="icon" class="shrink-0 bg-muted lg:hidden">
        <Icon icon="lucide:menu" class="h-5 w-5" />
      </Button>
    </SheetTrigger>

    <SheetContent side="left" class="flex flex-col">
      <SheetTitle>
        <div class="flex items-center">
          <a href="#">
            <img :src="imageSrc" alt="Logo" class="h-8 w-8" />
          </a>
          <h1 class="ml-4 font-bold">Studi Musicali Online</h1>
        </div>
      </SheetTitle>

      <SheetDescription></SheetDescription>

      <ScrollArea as-child>
        <nav class="flex flex-col gap-2 text-lg font-medium">
          <router-link
            v-for="item of props.items"
            :to="item.path"
            :class="[
              'flex items-center gap-4 rounded-xl px-3 py-2',
              isActive(item) ? 'bg-muted text-foreground' : 'text-muted-foreground hover:text-foreground'
            ]">
            <Icon :icon="item.icon" class="h-5 w-5" v-if="item.icon" />
            {{ $t(`commons.nav.${item.name}`) }}
          </router-link>

          <Separator class="my-2" />

          <router-link
            to="/advanced_search"
            :class="[
              'flex items-center gap-4 rounded-xl px-3 py-2',
              isActive({ path: '/advanced_search' })
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            ]">
            <Search /> {{ $t("commons.nav.advanced_search") }}
          </router-link>
        </nav>
      </ScrollArea>
    </SheetContent>
  </Sheet>
</template>
